import styled from 'styled-components'

export const TabelaWrapper = styled.div`
  position: relative;
  margin-bottom: 70px;
`

export const PaginacaoTabela = styled.div`
  > div {
    left: 0 !important;
    right: 0 !important;
    margin-left: 0px;
  }
`

export const QuantidadeLinhas = styled.div`
  color: ${({ theme }) => theme.cor9};
  font-family: RobotoRegular;
  font-size: 1em;
  line-height: 1em;
  margin-top: 15px;
  float: right;
`

export const ContainerAlerta = styled.div`
  width: 100%;
  display: grid;
  gap: 16px;
  justify-items: center;
`

export const MensagemAlerta = styled.span`
  text-align: center;
  color: ${({ theme }) => theme.cor9}!important;
`

export const TituloAlerta = styled.h1`
  font-size: 20px;
  font-weight: 500;
  color: ${({ theme }) => theme.cor9}!important;
`

export const ButtonDeletar = styled.button`
  box-shadow: none;
  background-color: transparent;
  border-color: transparent;
  width: 1.7em;
  height: 1.7em;
`

export const ImgDeletar = styled.img`
  margin-top: -10px !important;
`
